(function () {
    'use strict';

    angular
        .module('app')
        .controller('DashboardSetting', DashboardSetting);

    DashboardSetting.$inject = [
        'ChilliUserProfileService',
        'SystemService',
        'WindowTitleService'];

    function DashboardSetting(
        ChilliUserProfileService,
        SystemService,
        WindowTitleService) {
        /* jshint validthis:true */
        var vm = this;
        vm.dashboardSettingCriteria = { 'PageSize': 10 };
        vm.loading = true;
        vm.permissionDenied = false;
        
        activate();

        function activate() {
            WindowTitleService.setTitle('Dashboard Panels');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });

            function loadEverything() {
                return SystemService.getMenuListSize('Dashboard Panels')
                    .then(getListPageSizeOk, getListPageSizeError);
            }

            function getListPageSizeOk(data) {
                vm.dashboardSettingCriteria.PageSize = data;
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }
    }
})();
